import IconArrowChevronLeft from "@/components/Icon/IconArrowChevronLeft.svg";
import IconArrowChevronRight from "@/components/Icon/IconArrowChevronRight.svg";
import Image from "next/image";
import classNames from "classnames";

export default function ReviewPagination({ totalCount, pageSize, page, className, onChange = () => {} }) {
  const totalButtons = 5;
  const totalPages = Math.ceil(totalCount / pageSize);
  const isPreviousPageDisabled = page <= 1;
  const isNextPageDisabled = page >= totalPages;
  const start = (page - 1) * pageSize + 1;
  const end = page * pageSize > totalCount ? totalCount : page * pageSize;

  const generatePaginationButtons = () => {
    const buttons = [];
    if (totalPages <= totalButtons) {
      buttons.push(
        ...Array(totalPages)
          .fill(0)
          .map((_, i) => i + 1)
      );
    } else {
      if (page <= 2) {
        buttons.push(
          ...Array(totalButtons)
            .fill(0)
            .map((_, i) => i + 1)
        );
      } else {
        buttons.push(1);
        buttons.push("...");
        if (page + totalButtons - 1 > totalPages) {
          const newButtons = [
            ...Array(totalButtons - 1)
              .fill(0)
              .map((_, i) => totalPages - i),
          ];
          newButtons.reverse();
          buttons.push(...newButtons);
        } else {
          buttons.push(
            ...Array(totalButtons - 1)
              .fill(0)
              .map((_, i) => page + i)
          );
        }
      }
    }
    return buttons;
  };

  const paginationbuttons = generatePaginationButtons();

  return totalCount > 0 ? (
    <div className={classNames("w-fit flex flex-col gap-4 items-center", className)}>
      <p className="text-gray text-xs font-[500]">
        Products {start} - {end} of {totalCount}
      </p>
      <div className={classNames("flex items-center gap-2 mt-6")}>
        <PaginationButton
          onClick={() => onChange(page - 1)}
          disabled={isPreviousPageDisabled}
          icon={
            <Image
              src={IconArrowChevronLeft.src}
              width={20}
              height={20}
              className="w-5 h-5"
              alt="IconArrowChevronLeft"
            />
          }
        />
        {paginationbuttons.map((item, index) => (
          <PageButton key={index} item={item} currentPage={page} onClick={() => onChange(item)} />
        ))}
        <PaginationButton
          onClick={() => onChange(page + 1)}
          disabled={isNextPageDisabled}
          icon={
            <Image
              src={IconArrowChevronRight.src}
              width={20}
              height={20}
              className="w-5 h-5"
              alt="IconArrowChevronLeft"
            />
          }
        />
      </div>
    </div>
  ) : (
    <h3 className="mx-auto my-[60px] absolute bottom-[50px] lg:bottom-[200px]">No Products Found</h3>
  );
}

function PaginationButton({ disabled, icon, onClick }) {
  return (
    <button onClick={onClick} className={classNames("mx-4", { invisible: disabled, "cursor-pointer": !disabled })}>
      {icon}
    </button>
  );
}

function PageButton({ item, currentPage, onClick }) {
  const isActive = item === currentPage;
  const isEllipsis = item === "...";
  const buttonClass = classNames(
    "w-[30px] md:w-[48px] h-[42px] flex justify-center items-center rounded-[2px] font-bold",
    {
      "bg-black text-white": isActive,
      "text-black border-[1px] border-light-gray": isEllipsis,
      "cursor-pointer text-black border-[1px] border-light-gray hover:border-black": !isActive && !isEllipsis,
    }
  );

  return (
    <div
      onClick={() => {
        if (!isEllipsis) onClick();
      }}
      className={buttonClass}
    >
      {item}
    </div>
  );
}
